<template>
	<view>
		<u-popup :mask-close-able='false' border-radius="10" v-model="uploadShow" mode="center" z-index="40"
			width="500rpx" height="250rpx">
			<canvas class="mycanvas" canvas-id="mycanvas" @touchstart="touchstart" @touchmove="touchmove"
				@touchend="touchend"></canvas>
			<view class="footer">
				<view class="left" @click="clear" style="width: 25%;">清除</view>
				<button class="left" @click="finish" :disabled="isSubmitting"
					style="width: 25%;">{{ isSubmitting ? '提交中...' : '提交' }}</button>
			</view>
		</u-popup>
	</view>
</template>

<script>
	import request from '@/components/request'
	import vc from 'vue-cookie'
	var x = 20;
	var y = 20;
	export default {
		data() {
			return {
				ctx: '', //绘图图像
				points: [], //路径点集合 
				isEnd: false, // 是否结束签名
				uploadShow: true,
				recordId: '',
				drawWidth: '',
				drawHeight: '',
				isSubmitting: true
			}
		},
		/* 		onLoad(op) {
					//			this.recordId = op.recordId
					let that = this
					uni.getSystemInfo({
						success: function(res) {
							that.drawWidth = res.screenWidth;
							that.drawHeight = res.screenHeight * 0.8;
						},
					})

				}, */
		created() {
			this.screenWidth = screen.availWidth
			this.screenHeight = screen.availHeight
			this.ctx = uni.createCanvasContext("mycanvas", this); //创建绘图对象

			//设置画笔样式
			this.ctx.lineWidth = 8;
			this.ctx.lineCap = "round"
			this.ctx.lineJoin = "round"
			this.ctx.fillStyle = "#ffffff"
			this.ctx.fillRect(0, 0, this.drawWidth, this.drawHeight);
		},
		methods: {
			//触摸开始，获取到起点
			touchstart: function(e) {
				let startX = e.changedTouches[0].x;
				let startY = e.changedTouches[0].y;
				let startPoint = {
					X: startX,
					Y: startY
				};
				this.points.push(startPoint);
				//每次触摸开始，开启新的路径
				this.ctx.beginPath();
			},

			//触摸移动，获取到路径点
			touchmove: function(e) {
				let moveX = e.changedTouches[0].x;
				let moveY = e.changedTouches[0].y;
				let movePoint = {
					X: moveX,
					Y: moveY
				};
				this.points.push(movePoint); //存点
				let len = this.points.length;
				if (len >= 2) {
					this.draw(); //绘制路径
				}

			},

			// 触摸结束，将未绘制的点清空防止对后续路径产生干扰
			touchend: function() {
				this.points = [];
				this.isEnd = true
			},

			/* ***********************************************
			#   绘制笔迹
			#	1.为保证笔迹实时显示，必须在移动的同时绘制笔迹
			#	2.为保证笔迹连续，每次从路径集合中区两个点作为起点（moveTo）和终点(lineTo)
			#	3.将上一次的终点作为下一次绘制的起点（即清除第一个点）
			************************************************ */
			draw: function() {
				let point1 = this.points[0]
				let point2 = this.points[1]
				this.points.shift()
				this.ctx.moveTo(point1.X, point1.Y)
				this.ctx.lineTo(point2.X, point2.Y)
				this.ctx.stroke()
				this.ctx.draw(true)
			},

			//清空画布
			clear: function() {
				let that = this;
				uni.getSystemInfo({
					success: function(res) {
						debugger;
						let canvasw = res.windowWidth;
						let canvash = res.windowHeight;
						that.ctx.clearRect(0, 0, canvasw, canvash);
						that.ctx.draw(true);
					},
				})
			},

			//完成绘画并保存到本地
			/* 			finish: function() {
							let that = this
							let data = {
								recordId: that.recordId,
								type: 2,
								userId: that.loginInfo.userId
							}
							console.log(data)
							if (!this.isEnd) {
								uni.showToast({
									title: '请先完成签名',
									icon: "none",
									duration: 1500,
									mask: true
								})
								return
							}

							uni.canvasToTempFilePath({
								canvasId: 'mycanvas',
								width: this.drawWidth,
								height: this.drawHeight,
								destWidth: 500,
								destHeight: 250,
								success: function(res) {
									let path = res.tempFilePath;
									uni.saveImageToPhotosAlbum({
										filePath: path,
										success: function(su) {
											uni.uploadFile({
												url: BASE_URL +
													'DilimsUploadServlet', //开发者服务器 url
												header: {
													// HTTP 请求 Header, header 中不能设置 Referer
												},
												filePath: path, // 要上传文件资源的路径
												name: 'fileblock', // 文件对应的 key , 开发者在服务器端通过这个 key 可以获取到文件二进制内容
												formData: {
													// HTTP 请求中其他额外的 form data （即接口需要的其它参数）
													recordId: that.recordId,
													type: 2,
													userId: that.loginInfo.userId
												},
												success(uploadFileRes) {
													let data = JSON.parse(uploadFileRes.data)
													that.$utils.toast(data.resultMessage)
													setTimeout(() => {
														uni.navigateBack({
															delta: 1
														})
													}, 500)
												}
											})
										}
									});
								}
							})
						}, */
			// 生成图片
			finish: function() {
				debugger;
				this.isSubmitting = true;
				const canvas = document.querySelector('#mycanvas')
				const src = canvas.toDataURL('image/png')
				let pic = src;
				let id = null
				let url = window.location.href;
				const queryParams = this.getQueryParams(url)
				this.userName = queryParams.userName
				this.userId = queryParams.userId
				this.billProjectId = queryParams.billProjectId
				request.post('upload', {
					base64: pic,
					userId: that.userId,
					billProjectId: that.billProjectId
				}).then(res => {
					if (res.data.status === 20) {
						alert('绘制成功,请到pc端查看')
						window.opener = null
						window.close()
					}
				}).catch(function(err) {
					alert(err)
				}).finally(function() {
					// this.isSubmitting = false;
				})
			},
		},
	}
</script>

<style>
	.mycanvas {
		width: 100%;
		height: 72%;
		background-color: #ECECEC;
	}

	.footer {
		font-size: 16px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 10rpx;
	}

	.left,
	.right {
		line-height: 50upx;
		height: 50upx;
		width: 250upx;
		text-align: center;
		font-weight: bold;
		color: white;
		border-radius: 5upx;
	}

	.left {
		background: #007AFF;
	}

	.right {
		background: orange;
	}
</style>


// WEBPACK FOOTER //
// src/pages/signaturePadBig.vue